<template>
  <div class="u-dior">
    <div class="editor"></div>
  </div>
</template>
<script>
import E from "wangeditor";
export default {
  data() {
    return {
      editor: null,
      value: "",
      context:"",
      isPush:true
    };
  },
  name: "ue",
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.editor = new E(document.querySelector(".editor"));
      this.editor.customConfig.uploadImgShowBase64 = true; // 上传图片到服务器
      this.editor.customConfig.onchange = html => {
        // if(html!='' && html!= undefined){
        //   if(html.indexOf('src=')>-1){
        //     let num = html.indexOf('src=')
        //      let sub1 = html.substring(num)
        //      let num2 = sub1.indexOf('" ')
        //      let sub2 = sub1.substring(5,num2)
        //      // if(sub2.length/1024>50){
        //      //   alert('文件不得超过50KB')
        //      //   this.editor.txt.html = ''
        //      // }
        //    }
        // }
        this.$parent.texts.msg = html;
        if (this.$parent.msg && this.$parent.msg.detail) this.$parent.msg.detail = html;
        this.$emit('changeHtml', html)
      };
      this.editor.create();
      // if(this.content) this.editor.txt.html(this.content)
    }
  },
  props:{
    content:String
  },
  watch:{
    content(){// 重新设置编辑器内容
      if(this.isPush) {
        this.editor.txt.html(this.content);
        this.isPush = false;
      }
    }
  }
};
</script>
<style lang='scss'>
.u-dior {
  .editor {
    .w-e-toolbar {
      display: flex;
      flex-wrap: wrap;
    }
  }
}
</style>